/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentUseCasesControllerGetProcessingStepsQueryResponse, DocumentUseCasesControllerGetProcessingStepsPathParams, DocumentUseCasesControllerGetProcessingSteps401, DocumentUseCasesControllerGetProcessingSteps403 } from "../../models/documentUseCasesController/DocumentUseCasesControllerGetProcessingSteps";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { documentUseCasesControllerGetProcessingSteps } from "../../clients/document-use-casesService/documentUseCasesControllerGetProcessingSteps";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const documentUseCasesControllerGetProcessingStepsQueryKey = (processingId: DocumentUseCasesControllerGetProcessingStepsPathParams["processingId"]) => [{
  url: '/api/v1/documents/processings/:processingId/steps',
  params: {
    processingId: processingId
  }
}] as const;
export type DocumentUseCasesControllerGetProcessingStepsQueryKey = ReturnType<typeof documentUseCasesControllerGetProcessingStepsQueryKey>;
export function documentUseCasesControllerGetProcessingStepsQueryOptions(processingId: DocumentUseCasesControllerGetProcessingStepsPathParams["processingId"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = documentUseCasesControllerGetProcessingStepsQueryKey(processingId);
  return queryOptions<DocumentUseCasesControllerGetProcessingStepsQueryResponse, ResponseErrorConfig<DocumentUseCasesControllerGetProcessingSteps401 | DocumentUseCasesControllerGetProcessingSteps403>, DocumentUseCasesControllerGetProcessingStepsQueryResponse, typeof queryKey>({
    enabled: !!processingId,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return documentUseCasesControllerGetProcessingSteps(processingId, config);
    }
  });
}

/**
 * @description Returns all steps for a processing job with their statuses and key metadata as a JSON:API array.
 * @summary Get all steps for a processing workflow
 * {@link /api/v1/documents/processings/:processingId/steps}
 */
export function useDocumentUseCasesControllerGetProcessingSteps<TData = DocumentUseCasesControllerGetProcessingStepsQueryResponse, TQueryData = DocumentUseCasesControllerGetProcessingStepsQueryResponse, TQueryKey extends QueryKey = DocumentUseCasesControllerGetProcessingStepsQueryKey>(processingId: DocumentUseCasesControllerGetProcessingStepsPathParams["processingId"], options: {
  query?: Partial<QueryObserverOptions<DocumentUseCasesControllerGetProcessingStepsQueryResponse, ResponseErrorConfig<DocumentUseCasesControllerGetProcessingSteps401 | DocumentUseCasesControllerGetProcessingSteps403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? documentUseCasesControllerGetProcessingStepsQueryKey(processingId);
  const query = useQuery({
    ...documentUseCasesControllerGetProcessingStepsQueryOptions(processingId, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<DocumentUseCasesControllerGetProcessingSteps401 | DocumentUseCasesControllerGetProcessingSteps403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}